
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    openButton: 'Open',
    freeOpenButton: 'Open for free',
    itemsInCase: 'Items in case',
    balance: 'Balance',
    notFoundTitle: 'Case not found',
    notFoundText: 'This case is no longer available — it may have been taken down or the link is broken.',
    backToCases: 'Back to cases',
    similarCases: 'Similar cases',
  },
  ru: {
    openButton: 'Открыть',
    freeOpenButton: 'Открыть бесплатно',
    itemsInCase: 'Предметы в кейсе',
    balance: 'Баланс',
    notFoundTitle: 'Кейс не найден',
    notFoundText: 'Этого кейса больше нет — его убрали или ссылка битая.',
    backToCases: 'Вернуться к кейсам',
    similarCases: 'Похожие кейсы',
  },
  uz: {
    openButton: 'Ochish',
    freeOpenButton: 'Bepul ochish',
    itemsInCase: 'Keysdagi buyumlar',
    balance: 'Balans',
    notFoundTitle: 'Keys topilmadi',
    notFoundText: 'Bu keys endi yoʻq — uni olib tashlagan boʻlishi mumkin yoki havola buzilgan.',
    backToCases: 'Keyslarga qaytish',
    similarCases: 'Oʻxshash keyslar',
  },
  fa: {
    openButton: 'باز کن',
    freeOpenButton: 'رایگان باز کن',
    itemsInCase: 'آیتم‌های داخل کیس',
    balance: 'موجودی',
    notFoundTitle: 'کیس پیدا نشد',
    notFoundText: 'این کیس دیگر در دسترس نیست — یا برداشته شده یا لینک خراب است.',
    backToCases: 'برگشت به کیس‌ها',
    similarCases: 'کیس‌های مشابه',
  },
  pt: {
    openButton: 'Abrir',
    freeOpenButton: 'Abrir de graça',
    itemsInCase: 'Itens na caixa',
    balance: 'Saldo',
    notFoundTitle: 'Caixa não encontrada',
    notFoundText: 'Essa caixa não existe mais — ela foi removida ou o link está quebrado.',
    backToCases: 'Voltar para as caixas',
    similarCases: 'Caixas parecidas',
  },
  tr: {
    openButton: 'Aç',
    freeOpenButton: 'Ücretsiz aç',
    itemsInCase: 'Kasadaki eşyalar',
    balance: 'Bakiye',
    notFoundTitle: 'Kasa bulunamadı',
    notFoundText: 'Bu kasa artık yok — kaldırılmış ya da link bozuk.',
    backToCases: 'Kasalara dön',
    similarCases: 'Benzer kasalar',
  },
  uk: {
    similarCases: 'Схожі кейси',
    openButton: 'Відкрити',
    freeOpenButton: 'Відкрити безкоштовно',
    itemsInCase: 'Предмети в кейсі',
    balance: 'Баланс',
    notFoundTitle: 'Кейс не знайдено',
    notFoundText: 'Цього кейса більше немає — його прибрали або посилання зламане.',
    backToCases: 'Повернутися до кейсів',
  },
  de: {
    similarCases: 'Ähnliche Cases',
    openButton: 'Öffnen',
    freeOpenButton: 'Gratis öffnen',
    itemsInCase: 'Items im Case',
    balance: 'Guthaben',
    notFoundTitle: 'Case nicht gefunden',
    notFoundText: 'Dieser Case ist nicht mehr verfügbar — er wurde entfernt oder der Link ist kaputt.',
    backToCases: 'Zurück zu den Cases',
  },
  es: {
    similarCases: 'Cajas similares',
    openButton: 'Abrir',
    freeOpenButton: 'Abrir gratis',
    itemsInCase: 'Objetos de la caja',
    balance: 'Saldo',
    notFoundTitle: 'Caja no encontrada',
    notFoundText: 'Esta caja ya no está disponible: la retiraron o el enlace está roto.',
    backToCases: 'Volver a las cajas',
  },
  pl: {
    similarCases: 'Podobne skrzynki',
    openButton: 'Otwórz',
    freeOpenButton: 'Otwórz za darmo',
    itemsInCase: 'Przedmioty w skrzynce',
    balance: 'Saldo',
    notFoundTitle: 'Nie znaleziono skrzynki',
    notFoundText: 'Tej skrzynki już nie ma — została usunięta albo link jest zepsuty.',
    backToCases: 'Wróć do skrzynek',
  },
});
